import { Leaf, Phone, X, Download, Menu } from "lucide-react";
import { createPortal } from "react-dom";
import noodles from "./images/noodles.png";
import greenchilli from "./images/greencilli.png";
import leaf from "./images/leaf.png";
import leafBlur from "./images/leafblue.png";
import cabageleave from "./images/cabageleave.png";
import { scrollToTop } from "../../utils/index";
import { useEffect, useState } from "react";
import autheticate from "./images/autheticate.png";
import fresh from "./images/fresh.png";
import cozy from "./images/cozy.png";
import CarouselFood from "./CarouselFood";
import box1 from "./images/box1.png";
import box2 from "./images/box2.jpg";
import box3 from "./images/box3.png";
import box4 from "./images/box4.jpg";
import box5 from "./images/box5.png";
import box6 from "./images/box6.png";
import box7 from "./images/box7.jpg";
import box8 from "./images/box8.jpg";
import menuPdf from "./menu.pdf";

export default function RestaurantComponent() {
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    scrollToTop();
  }, []);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [menuOpen]);

  return (
    <div className="min-h-screen bg-white">
      {menuOpen &&
        createPortal(
          <div
            onClick={() => setMenuOpen(false)}
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              zIndex: 9999,
              backgroundColor: "rgba(0,0,0,0.75)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "16px",
            }}
          >
            <div
              onClick={(e) => e.stopPropagation()}
              style={{
                width: "min(780px, 95vw)",
                height: "90vh",
                backgroundColor: "#ffffff",
                borderRadius: "16px",
                boxShadow: "0 25px 60px rgba(0,0,0,0.4)",
                display: "flex",
                flexDirection: "column",
                overflow: "hidden",
              }}
            >
              {/* Header */}
              <div
                style={{
                  background: "linear-gradient(135deg, #22c55e, #16a34a)",
                  padding: "14px 20px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  flexShrink: 0,
                }}
              >
                {/* Left */}
                <div
                  style={{ display: "flex", alignItems: "center", gap: "12px" }}
                >
                  <div
                    style={{
                      width: "36px",
                      height: "36px",
                      backgroundColor: "rgba(255,255,255,0.2)",
                      borderRadius: "8px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Menu size={16} color="white" />
                  </div>
                  <div>
                    <p
                      style={{
                        color: "white",
                        fontWeight: 700,
                        fontSize: "16px",
                        margin: 0,
                        lineHeight: 1,
                      }}
                    >
                      Our Menu
                    </p>
                    <p
                      style={{
                        color: "#bbf7d0",
                        fontSize: "12px",
                        margin: 0,
                        marginTop: "3px",
                      }}
                    >
                      Browse our full menu
                    </p>
                  </div>
                </div>

                {/* Right */}
                <div
                  style={{ display: "flex", alignItems: "center", gap: "8px" }}
                >
                  <a
                    href={menuPdf}
                    download="menu.pdf"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                      backgroundColor: "white",
                      color: "#15803d",
                      padding: "8px 16px",
                      borderRadius: "999px",
                      fontSize: "13px",
                      fontWeight: 600,
                      textDecoration: "none",
                      whiteSpace: "nowrap",
                    }}
                  >
                    <Download size={14} />
                    Download
                  </a>
                  <button
                    onClick={() => setMenuOpen(false)}
                    style={{
                      width: "36px",
                      height: "36px",
                      backgroundColor: "rgba(255,255,255,0.2)",
                      border: "none",
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                    }}
                  >
                    <X size={18} color="white" />
                  </button>
                </div>
              </div>

              {/* PDF Viewer */}
              <div style={{ flex: 1, minHeight: 0, overflow: "hidden" }}>
                <iframe
                  src={`${menuPdf}#toolbar=0&navpanes=0&scrollbar=1&view=FitH`}
                  style={{
                    width: "100%",
                    height: "100%",
                    border: "none",
                    display: "block",
                  }}
                  title="Restaurant Menu"
                />
              </div>
            </div>
          </div>,
          document.body,
        )}

      {/* Hero Section */}
      <div
        className="relative px-6 py-16 pb-32"
        style={{ backgroundColor: "rgba(255, 254, 219, 1)" }}
      >
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-6">
            <h1 className="text-4xl lg:text-5xl font-bold text-gray-800 leading-tight">
              Your Party, Our Flavors -<br />
              Call Now for a Quote!
            </h1>
            <div className="flex flex-wrap gap-4">
              <button className="bg-green-500 text-white px-6 py-3 rounded-full font-semibold hover:bg-green-600 transition-colors flex items-center gap-2">
                <Phone className="w-5 h-5" />
                CALL NOW
              </button>
              <button
                onClick={() => setMenuOpen(true)}
                className="bg-white text-gray-700 px-6 py-3 rounded-full font-bold hover:bg-gray-50 transition-colors flex items-center gap-2 border-2 border-gray-200"
              >
                <Menu className="w-5 h-5" />
                CHECK MENU
              </button>
            </div>
          </div>

          <div className="relative flex justify-center">
            <div className="relative">
              <div className="w-96 h-96 relative z-10">
                <div className="w-full h-full bg-orange-100 rounded-full flex items-center justify-center border-8 border-white shadow-2xl overflow-hidden">
                  <div className="w-80 h-80 bg-orange-200 rounded-full flex items-center justify-center overflow-hidden">
                    <img
                      className="w-72 h-72 object-cover rounded-full"
                      src={noodles}
                      alt="Delicious Noodles"
                    />
                  </div>
                </div>
              </div>
              <div className="absolute -top-2 -left-4 w-10 h-10 bg-green-200 rounded-full flex items-center justify-center shadow-lg">
                <Leaf className="w-6 h-6 text-green-600" />
              </div>
              <div className="absolute top-8 -right-6 w-8 h-8 bg-green-300 rounded-full flex items-center justify-center shadow-lg">
                <Leaf className="w-5 h-5 text-green-700" />
              </div>
              <div className="absolute -bottom-4 -left-8 w-12 h-12 bg-green-100 rounded-full flex items-center justify-center shadow-lg">
                <Leaf className="w-7 h-7 text-green-500" />
              </div>
              <div className="absolute bottom-12 -right-2 w-6 h-6 bg-green-200 rounded-full flex items-center justify-center shadow-lg">
                <Leaf className="w-4 h-4 text-green-600" />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Our Promise Section */}
      <div className="py-16 px-6 -mt-16 pt-24">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl font-bold text-gray-800 mb-12">
            Our Promise to You
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="flex flex-col items-center space-y-4">
              <div className="w-16 h-16 bg-gray-100 rounded-lg flex items-center justify-center">
                <img src={fresh} alt="Fresh Ingredients" className="w-8 h-8" />
              </div>
              <h3 className="text-lg font-semibold text-gray-800">
                Fresh Ingredients
              </h3>
            </div>
            <div className="flex flex-col items-center space-y-4">
              <div className="w-16 h-16 bg-gray-100 rounded-lg flex items-center justify-center">
                <img
                  src={autheticate}
                  alt="Authentic Flavors"
                  className="w-8 h-8"
                />
              </div>
              <h3 className="text-lg font-semibold text-gray-800">
                Authentic Flavors
              </h3>
            </div>
            <div className="flex flex-col items-center space-y-4">
              <div className="w-16 h-16 bg-gray-100 rounded-lg flex items-center justify-center">
                <img src={cozy} alt="Cozy Ambience" className="w-8 h-8" />
              </div>
              <h3 className="text-lg font-semibold text-gray-800">
                Cozy Ambience
              </h3>
            </div>
          </div>
        </div>
      </div>

      {/* Cozy Ambience Section */}
      <div
        className="py-16 px-6"
        style={{
          background: "linear-gradient(180deg, #B6D8FF 0%, #FFFFFF 100%)",
        }}
      >
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-6">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-800 leading-tight">
              Cozy Ambience,
              <br />
              Unforgettable Flavours
            </h2>
            <p className="text-gray-600 leading-relaxed">
              Step into a warm and inviting space where every corner feels like
              home. From soft lighting, comfortable seating, and soothing music
              set the perfect mood.
            </p>
          </div>
          <div>
            <CarouselFood />
          </div>
        </div>
      </div>

      {/* Food Gallery Section */}
      <div className="py-16 px-6 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            <div className="bg-red-100 rounded-lg h-52 flex items-center justify-center">
              <img
                src={box1}
                alt="Food 1"
                className="w-full h-full object-cover rounded-lg"
              />
            </div>
            <div className="bg-yellow-100 rounded-lg h-52 flex items-center justify-center">
              <img
                src={box2}
                alt="Food 2"
                className="w-full h-full object-cover rounded-lg"
              />
            </div>
            <div className="bg-brown-100 rounded-lg h-52 flex items-center justify-center">
              <img
                src={box3}
                alt="Food 3"
                className="w-full h-full object-cover rounded-lg"
              />
            </div>
            <div className="bg-orange-100 rounded-lg h-52 flex items-center justify-center">
              <img
                src={box4}
                alt="Food 4"
                className="w-full h-full object-cover rounded-lg"
              />
            </div>
            <div className="bg-red-200 rounded-lg h-52 flex items-center justify-center">
              <img
                src={box5}
                alt="Food 5"
                className="w-full h-full object-cover rounded-lg"
              />
            </div>
            <div className="bg-green-100 rounded-lg h-52 flex items-center justify-center">
              <img
                src={box6}
                alt="Food 6"
                className="w-full h-full object-cover rounded-lg"
              />
            </div>
            <div className="bg-yellow-200 rounded-lg h-52 flex items-center justify-center">
              <img
                src={box7}
                alt="Food 7"
                className="w-full h-full object-cover rounded-lg"
              />
            </div>
            <div className="bg-gray-100 rounded-lg h-52 flex items-center justify-center">
              <img
                src={box8}
                alt="Food 8"
                className="w-full h-full object-cover rounded-lg"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
